import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useContent } from "../context/ContentContext";
import { CONTACT, IMAGES } from "../mock";

const Footer = () => {
  const { t } = useLanguage();
  const { content } = useContent();
  const contact = {
    addressFull: content.contact_address_full || CONTACT.addressFull,
    phone: content.contact_phone || CONTACT.phone,
    phoneRaw: (content.contact_phone || CONTACT.phone).replace(/[^0-9+]/g, ""),
    email: content.contact_email || CONTACT.email,
    hours: content.contact_hours || CONTACT.hours,
  };
  const links = [
    { to: "/", label: t("nav_home") },
    { to: "/about", label: t("nav_about") },
    { to: "/services", label: t("nav_services") },
    { to: "/gallery", label: t("nav_gallery") },
    { to: "/booking", label: t("nav_booking") },
  ];

  return (
    <footer className="bg-[#0a1024] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={content.logo_image || IMAGES.logo} alt="Barbo Factory" className="w-11 h-11 object-contain" />
            <span className="text-white font-extrabold tracking-wide text-lg">BARBO FACTORY</span>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed max-w-xs">{t("footer_tagline")}</p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t("footer_links")}</h4>
          <ul className="space-y-2">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-gray-400 text-sm hover:text-[#67e8f9] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t("footer_contact")}</h4>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#22d3ee] mt-0.5 shrink-0" />
              <span>{contact.addressFull}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#22d3ee] shrink-0" />
              <a href={`tel:${contact.phoneRaw}`} className="hover:text-[#67e8f9] transition-colors">{contact.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#22d3ee] shrink-0" />
              <a href={`mailto:${contact.email}`} className="hover:text-[#67e8f9] transition-colors">{contact.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-4 h-4 text-[#22d3ee] mt-0.5 shrink-0" />
              <span>{contact.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-gray-500 text-xs">© {new Date().getFullYear()} Barbo Factory. {t("footer_rights")}</p>
        <Link to="/admin" className="text-gray-600 text-xs hover:text-gray-400 transition-colors">Admin</Link>
      </div>
    </footer>
  );
};

export default Footer;
